import React, { Component } from "react";

import { Layout, Breadcrumb, Tabs, PageHeader, Select, Space } from "antd";
import { RightOutlined } from "@ant-design/icons";

import TodayTab from "./TodayTab";
import WeekTab from "./WeekTab";
import MonthTab from "./MonthTab";

import { all as AllCareUnit } from "../../api/CareUnit.js";

import moment from "moment";

const { Option } = Select;

const layoutSelect = {
  showSearch: true,
  allowClear: true,
  defaultActiveFirstOption: true,
  optionFilterProp: "children",
  style: {
    minWidth: 350
  }
};

const { Content } = Layout;
const { TabPane } = Tabs;

const FILTERS_STORED = [
  "tabCalendarKey",
  "selectedDate",
  "selectedCareUnitIds",
];

/**
 *
 */
class Calendar extends Component {
  /**
   *
   * @param {*} props
   */
  constructor(props) {
    super(props);

    let filtersCalendar = localStorage.getItem('filters_calendar', null);
    let filtersStorage = this.loadFiltersStorage(filtersCalendar);

    this.state = {
      tabCalendarKey: filtersStorage.tabCalendarKey,
      selectedDate: filtersStorage.selectedDate,
      selectedCareUnitIds: filtersStorage.selectedCareUnitIds,
      careUnits: [],
    };

    this.monthTabRef = React.createRef();
    this.weekTabRef = React.createRef();

    this.selectDate = this.selectDate.bind(this);
    this.onChangeActiveCalendarkey = this.onChangeActiveCalendarkey.bind(this);
    this.onChangeCareUnits = this.onChangeCareUnits.bind(this);
    this.onChangeTodayTab = this.onChangeTodayTab.bind(this);
  }

  /**
   * 
   */
  componentDidMount() {
    const stateHistory = window.history.state?.state;

    if (stateHistory !== undefined && stateHistory.hasOwnProperty("event")) {
      if (stateHistory.event === "out_patient") {
        this.selectDate(moment());
      } else if (stateHistory.event === "show_calendar") {
        this.setState({ tabCalendarKey: "week" });
      }
    }

    this.fetchCareUnits('');
  }

  /**
   *
   * @param {*} filtersStorage
   */
  loadFiltersStorage(filtersStorage) {
    let newState = {
      tabCalendarKey: "week",
      selectedDate: moment(),
      selectedCareUnitIds: [],
    };

    if (!filtersStorage) {
      return newState;
    }

    filtersStorage = JSON.parse(filtersStorage);

    Object.keys(filtersStorage).forEach(item => {
      if (FILTERS_STORED.includes(item)) {
        if (item === "selectedDate") {
          filtersStorage[item] = moment(filtersStorage[item]);
        }

        newState[item] = filtersStorage[item];
      }
    });

    return newState;
  }

  /**
   *
   */
  storeFiltersInStorage() {
    let filters = {};

    FILTERS_STORED.forEach(item => {
      filters[item] = this.state[item];
    });

    filters = JSON.stringify({ ...filters });
    localStorage.setItem('filters_calendar', filters);
  };

  /**
   * 
   * @param {*} search 
   * @returns 
   */
  fetchCareUnits(search) {
    let payload = {
      current: 1,
      pageSize: 10,
      q: {
        search,
      },
    };

    return AllCareUnit(payload)
      .then(data => {
        this.setState({ careUnits: data.results });
      });
  }

  /**
   * 
   * @param {*} key 
   */
  onChangeActiveCalendarkey(key) {
    this.setState({ tabCalendarKey: key }, () => {
      this.storeFiltersInStorage();
    });
  }

  /**
   * 
   * @param {*} value 
   */
  onChangeCareUnits(value) {
    this.setState({ selectedCareUnitIds: value }, () => {
      this.storeFiltersInStorage();
    });
  }

  /**
   * 
   */
  onChangeTodayTab() {
    if (this.weekTabRef.current) {
      this.weekTabRef.current.reload();
    }

    if (this.monthTabRef.current) {
      this.monthTabRef.current.reload();
    }
  }

  /**
   * 
   * @param {*} newStartDate 
   */
  selectDate(newStartDate) {
    this.setState({ selectedDate: moment(newStartDate) }, () => {
      this.storeFiltersInStorage();
    });
  }

  /**
   * 
   * @returns 
   */
  render() {
    let { selectedDate, careUnits, selectedCareUnitIds } = this.state;

    let careUnitOptions = careUnits.map((option, index) => (
      <Option key={index} value={option.id}>{option.name}</Option>
    ));

    return (
      <Content
        style={{
          margin: "24px 16px",
          padding: 24,
          minHeight: 280,
        }}
      >
        <Breadcrumb
          style={{ padding: 24 }}
          separator={<RightOutlined style={{ fontSize: "75%" }} />}
        >
          <Breadcrumb.Item>
            <a href="/home">Accueil</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Visualisation</Breadcrumb.Item>
        </Breadcrumb>
        <PageHeader ghost={false} title="Calendrier" />
        <div
          className="site-layout-background pt-0"
          style={{ padding: 24, minHeight: 360 }}
        >
          <Space direction="vertical" className="mt-2 mb-4">
            <label>Unité(s) de soin(s) :</label>
            <Select
              {...layoutSelect}
              mode="multiple"
              placeholder="Choisissez votre/vos unité(s)"
              notFoundContent="Rechercher une unité de soin"
              value={selectedCareUnitIds.filter(careUnitId => {
                let careUnit = careUnits.find(item => item.id === careUnitId);
                return (!!careUnit);
              })}
              onChange={this.onChangeCareUnits}
            >
              {careUnitOptions}
            </Select>
          </Space>
          <Tabs
            activeKey={this.state.tabCalendarKey}
            onChange={this.onChangeActiveCalendarkey}
          >
            <TabPane tab="Vision hebdomadaire" key="week">
              <WeekTab
                ref={this.weekTabRef}
                selectedDate={selectedDate}
                careUnitIds={selectedCareUnitIds}
                selectDate={this.selectDate}
              />
            </TabPane>
            <TabPane tab="Vision mensuelle" key="month">
              <MonthTab
                ref={this.monthTabRef}
                selectedDate={selectedDate}
                careUnitIds={selectedCareUnitIds}
                selectDate={this.selectDate}
              />
            </TabPane>
          </Tabs>
        </div>
        <br />
        <PageHeader ghost={false} title="Séjours sur la période">
          Jour: {moment(selectedDate).format("DD/MM/YYYY")}
        </PageHeader>
        <div
          className="site-layout-background pt-0"
          style={{ padding: 24, minHeight: 360 }}
        >
          <TodayTab
            selectedDate={selectedDate}
            careUnitIds={selectedCareUnitIds}
            onChange={this.onChangeTodayTab}
          />
        </div>
      </Content>
    );
  }
}

export default Calendar;
